import { keyifyParamsForFiltersRequest } from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersSelectors';
import { updateFilterById } from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersActions';

export function setSelectedItemsFromDialog(filter, selectedItems) {
  return (dispatch, getState) => {
    const filterId = filter.get('id');
    const key = keyifyParamsForFiltersRequest(getState());
    const groups = filter.get('groups');
    const selectedIds = selectedItems.map(({ id }) => id);

    const nextGroups = groups.map((group) => {
      if (selectedIds.includes(group.get('id'))) {
        return group.set('selected', true);
      }
      return group;
    });

    dispatch(
      updateFilterById(key, filterId, {
        selectedItemsFromDialog: selectedItems,
        groups: nextGroups,
      })
    );
  };
}

export function clearSelectedItemsFromDialog(filter) {
  return (dispatch, getState) => {
    const filterId = filter.get('id');
    const key = keyifyParamsForFiltersRequest(getState());

    dispatch(
      updateFilterById(key, filterId, {
        selectedItemsFromDialog: null,
      })
    );
  };
}

export function convertSelectedItemsFromDialogToProperties(filter, selectedItems) {
  const propertiesMap = selectedItems.reduce((acc, selectedItem) => {
    const sortingType = selectedItem.get('sortingType');
    const sorting = selectedItem.get('sorting');
    const index = selectedItem.get('index');

    const key = `${sortingType}/${sorting}`;
    acc[key] = acc[key] || {
      title: filter.get('title'),
      property: filter.get('id'),
      indexes: [],
      ascending: sorting === 'ascending',
      ...(sortingType === 'byValue' && { byValue: true }),
      override: true,
    };
    acc[key].indexes.push(index);

    return acc;
  }, {});

  return Object.values(propertiesMap);
}
